import type { Apollo } from 'src/gql/generated';

export type DocumentPartComment = NonNullable<
  Apollo.GetDocumentPartsQuery['documentParts']
>['comments'][number];

export enum ExportDocumentCommentsMode {
  All = 'all',
  PublicOnly = 'public-only',
}

export function hasPrivateCommentsForExport(
  comments: Pick<DocumentPartComment, 'isPrivate'>[]
): boolean {
  return comments.some(comment => comment.isPrivate);
}

export function filterCommentsForExport<TComment extends Pick<DocumentPartComment, 'isPrivate'>>(
  comments: TComment[],
  mode: ExportDocumentCommentsMode
): TComment[] {
  if (mode === ExportDocumentCommentsMode.All) return comments;

  return comments.filter(comment => !comment.isPrivate);
}
